import ExpoConstants from 'expo-constants';

/**
 * Typed singleton for reading `expo.extra` values and app metadata.
 */

interface ApiExtras {
	url: string;
}

interface EasExtras {
	projectId?: string;
}

interface AppExtras {
	environment: string;
	baseUrl: string;
	api: ApiExtras;
	eas?: EasExtras;
	supportMail?: string;
	appStoreUrl?: string;
	playStoreUrl?: string;
}

const rawExtra = (ExpoConstants.expoConfig?.extra ?? {}) as Partial<AppExtras>;

export const Config = {
	appName: ExpoConstants.expoConfig?.name ?? '',
	appVersion: ExpoConstants.expoConfig?.version ?? '',
	environment: rawExtra.environment ?? 'production',
	baseUrl: rawExtra.baseUrl ?? '',
	apiUrl: rawExtra.api?.url ?? '',
	easProjectId: rawExtra.eas?.projectId ?? '',
	supportMail: rawExtra.supportMail ?? '',
	appStoreUrl: rawExtra.appStoreUrl ?? '',
	playStoreUrl: rawExtra.playStoreUrl ?? '',
} as const;

export default Config;
